// Language-independent assets & layout meta
export const CONTACT = {
  brand: "Bardine PA",
  name: "Nicola Bardine",
  role: "Senior Project Manager",
  email: "nicola@bardinepa.ch",
  phone: "+41 77 433 86 87",
  address: "Rue Étienne-Dumont 18 · 1204 Genève",
  calendly: "https://calendly.com/bardinepa",
  whatsapp: "41774338687",
};

export const HERO_IMAGE = "/projects/hero-geneva.jpg";
export const PROFILE_IMAGE = "/projects/profile-nicola.jpg";

// Project layout meta — text lives in i18n (same order)
export const PROJECT_META = [
  { image: "/projects/artlab-facade.jpg", span: "lg:col-span-7", ratio: "aspect-[3/2]" },
  { image: "/projects/benetti-yacht.jpg", span: "lg:col-span-5", ratio: "aspect-[3/2]" },
  { image: "/projects/hospitality-a.jpg", images: ["/projects/hospitality-a.jpg", "/projects/hospitality-b.jpg"], span: "lg:col-span-5", ratio: "aspect-[3/4]" },
  { image: "/projects/nextyacht.jpg", span: "lg:col-span-7", ratio: "aspect-[3/2]" },
  { image: "/projects/sombor-factory.jpg", span: "lg:col-span-12", ratio: "aspect-[16/9]" },
];

export const EDUCATION = [
  { fr: { school: "SDA Bocconi School of Management", detail: "Executive Program in Real Estate Finance — EPFIRE", year: "2021–2022" },
    en: { school: "SDA Bocconi School of Management", detail: "Executive Program in Real Estate Finance — EPFIRE", year: "2021–2022" } },
  { fr: { school: "Università di Genova", detail: "BSc Yacht Design & Engineering", year: "2012" },
    en: { school: "University of Genoa", detail: "BSc Yacht Design & Engineering", year: "2012" } },
  { fr: { school: "ISIPM®", detail: "Project Management Base Certification", year: "2012" },
    en: { school: "ISIPM®", detail: "Project Management Base Certification", year: "2012" } },
];
